import { createElement, useRef, useState } from 'react'

import moment from 'moment'

const WebDatePicker = ({
  onChange,
  onBlur,
  value,
  style = {},
  maxDate,
  minDate,
  placeholder = 'DD/MM/YYYY',
  isWebView = false,
  disabled,
}) => {
  const dateValue = value ? moment(value).format('YYYY-MM-DD') : ''
  const dateRef = useRef()
  const [hasValue, setHasValue] = useState(!!value)

  const handleInterviewDateClick = () => {
    dateRef.current?.showPicker?.()
    onBlur?.()
  }

  const handleChange = (e) => {
    const newValue = e.target.value
    setHasValue(!!newValue)
    onChange?.(e)
  }

  const handleBlur = (e) => {
    setHasValue(!!e.target.value)
    onBlur?.(e)
  }

  const originalDateInput = () => {
    return createElement('input', {
      type: 'date',
      value: dateValue,
      onChange: onChange,
      onKeyDown: (e) => e.preventDefault(),
      max:
        maxDate === undefined
          ? moment().subtract(1, 'days').format('YYYY-MM-DD')
          : maxDate,
      min: minDate,
      onClick: handleInterviewDateClick,
      ref: dateRef,
      disabled,
      style: {
        backgroundColor: 'rgb(245 247 251)',
        padding: 12,
        borderRadius: '0.35rem',
        width: '100%',
        borderColor: 'rgb(209 217 233)',
        lineHeight: '1.25rem',
        WebkitAppearance: 'none',
        borderWidth: 1,
        paddingLeft: 27,
        paddingTop: 16,
        zIndex: 1,
        background: 'transparent',
        ...style,
      },
    })
  }

  const webViewDateInput = () => {
    return createElement(
      'div',
      {
        style: {
          position: 'relative',
          width: '100%',
        },
      },
      [
        // Date input
        createElement('input', {
          key: 'date-input',
          type: 'date',
          value: dateValue,
          onChange: handleChange,
          onBlur: handleBlur,
          onKeyDown: (e) => e.preventDefault(),
          max:
            maxDate === undefined
              ? moment().subtract(1, 'days').format('YYYY-MM-DD')
              : maxDate,
          min: minDate,
          onClick: handleInterviewDateClick,
          ref: dateRef,
          style: {
            backgroundColor: 'rgb(245 247 251)',
            padding: 12,
            borderRadius: '0.35rem',
            width: '100%',
            borderColor: 'rgb(209 217 233)',
            lineHeight: '1.25rem',
            WebkitAppearance: 'none',
            borderWidth: 1,
            paddingLeft: 27,
            paddingTop: 16,
            zIndex: 2,
            background: 'transparent',
            position: 'relative',
            ...style,
          },
        }),
        // Placeholder overlay - only show when no value
        !hasValue &&
          createElement(
            'div',
            {
              key: 'placeholder',
              style: {
                position: 'absolute',
                top: 16,
                left: 35,
                color: '#1C1D1F',
                fontSize: '14px',
                fontFamily: 'JioType',
                pointerEvents: 'none',
                zIndex: 1,
              },
            },
            placeholder
          ),
      ]
    )
  }

  return isWebView ? webViewDateInput() : originalDateInput()
}

export { WebDatePicker }
